import script from "./CategoryPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryPill.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryPill.vue?vue&type=style&index=0&id=7514df14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7514df14"]])

export default __exports__